import * as Config from '../../../../config';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

let lastPosition = 0;
let lastOutro = 0;
const useFillWaveform = (context = null, active, id, fullWidth, duration, baseStart, baseEnd, onNext, cursorPosition, currentAutomix) => {
  const [lock, setLock] = useState(false);
  const storePopup = useSelector(state => state.storePopup);

  const startLine = Math.round((baseStart * fullWidth) / duration);
  const endLine = Math.round((baseEnd * fullWidth) / duration);

  const seek = () => {
    if (cursorPosition !== null && parseInt(currentAutomix.currentid) === parseInt(id)) {
     const zone = endLine - startLine;
      if (startLine < cursorPosition && cursorPosition < endLine) {
        const durationAvailable = baseEnd - baseStart;
        const accurancy = (durationAvailable < 120) ? 0.09 : 0.025;
        const pourcent = (((cursorPosition + 1) - startLine) / zone) - accurancy;
        
        window['YouDJ'] && window['YouDJ'].automix_seek(pourcent);  
      } else {
        storePopup.automix();
      }
    }
  };

  useEffect( () => {
    if (context && active && fullWidth /*&& currentAutomix.position > 0*/) {
      const { ctx, canvas } = context;
     
      if (currentAutomix && currentAutomix.state === 'play') {
        lastPosition = currentAutomix.position;
        lastOutro = currentAutomix.outro;
      } else if (currentAutomix && currentAutomix.state === 'pause' && currentAutomix.position < lastPosition) {
        currentAutomix.position = lastPosition;
        currentAutomix.outro = lastOutro;
      }

      let part = startLine;
      if (parseInt(currentAutomix.currentid) === parseInt(id) || currentAutomix.state === 'pause') {
        part = Math.round(((baseStart + currentAutomix.position) * fullWidth) / duration);
      } else if (currentAutomix.mixingid === id) {
        part = Math.round(((baseStart + currentAutomix.mixingpos) * fullWidth) / duration);
      }
      const outro = Math.round(((baseEnd - currentAutomix.outro) * fullWidth) / duration) - 1; // ANTICIPATE THE TRANSITION 2s FOR PERFORMANCE
      
      if (parseInt(currentAutomix.currentid) === parseInt(id) && currentAutomix.state === 'mixing' && currentAutomix.mixingpos > 5 && !lock) {
        setLock(true);
        onNext();
      }

      // Before Preview
      ctx.fillStyle = Config.BLACK_2;
      ctx.fillRect(0, 0, startLine, canvas.height);

      // Content 1st
      if (part < outro) {
        ctx.fillStyle = Config.BRAND_PRIMARY;
        ctx.fillRect(startLine, 0, part, canvas.height);
        ctx.fillStyle = Config.BLACK_5;
        ctx.fillRect(part, 0, outro, canvas.height);
      } else {
        ctx.fillStyle = Config.BRAND_PRIMARY;
        ctx.fillRect(startLine, 0, outro, canvas.height);
      }

      // Outro
      ctx.fillStyle = Config.BLACK_5; //Config.TYPE_LIGHT;
      ctx.fillRect(outro, 0, outro + 1, canvas.height);

      // Content 2st
      if (part < outro) {
        ctx.fillStyle = '#414142'; //Config.BLACK_5;
        ctx.fillRect(outro + 1, 0, endLine, canvas.height);
        } else {
        ctx.fillStyle = Config.BRAND_PRIMARY;
        ctx.fillRect(outro + 1, 0, part, canvas.height);
        ctx.fillStyle = '#414142'; //Config.BLACK_5;
        ctx.fillRect(part, 0, endLine, canvas.height);
      }

      // After Preview
      ctx.fillStyle = Config.BLACK_2;
      ctx.fillRect(endLine + 1, 0, fullWidth, canvas.height); 
    }
  }, [id, context, active, duration, fullWidth, currentAutomix, lock, onNext, baseStart, baseEnd, startLine, endLine])

  return { seek };
};

export default useFillWaveform;
